(function(){
  function money(c){var f=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:f}).format(c/100)}catch(e){return '$'+(c/100).toFixed(2)}}
  function init(root){
    if(root.dataset.clpInit)return; root.dataset.clpInit=1;
    var variants=JSON.parse(root.querySelector('[data-variants]').textContent);
    var slides=[].slice.call(root.querySelectorAll('.clp-gallery__slide'));
    var thumbs=[].slice.call(root.querySelectorAll('[data-thumb]'));
    var track=root.querySelector('[data-thumb-track]');
    function show(i){ if(i<0)i=slides.length-1; if(i>=slides.length)i=0;
      slides.forEach(function(s,k){s.classList.toggle('is-active',k===i)});
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i)});
      var t=thumbs[i]; if(t&&track){track.scrollTo({left:t.offsetLeft-track.offsetLeft-track.clientWidth/2+t.clientWidth/2,behavior:'smooth'})}
      root.dataset.cur=i;}
    thumbs.forEach(function(t){t.addEventListener('click',function(){show(+t.dataset.thumb)})});
    var p=root.querySelector('[data-thumb-prev]'),n=root.querySelector('[data-thumb-next]');
    p&&p.addEventListener('click',function(){show((+root.dataset.cur||0)-1)});
    n&&n.addEventListener('click',function(){show((+root.dataset.cur||0)+1)});
    // swipe on main
    var main=root.querySelector('.clp-gallery__main'),sx=null;
    main&&main.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    main&&main.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40)show((+root.dataset.cur||0)+(dx<0?1:-1));sx=null});
    function findV(o1,o2){for(var i=0;i<variants.length;i++){if(variants[i].o1===o1&&variants[i].o2===o2)return variants[i]}return null}
    function showMedia(id){for(var i=0;i<slides.length;i++){if(+slides[i].dataset.mediaId===id){show(i);return}}}
    // kits
    var kits=[].slice.call(root.querySelectorAll('[data-kit]'));
    var gifts=[].slice.call(root.querySelectorAll('.clp-gift'));
    var stickyPrice=root.querySelector('[data-sticky-price]'),stickyCompare=root.querySelector('[data-sticky-compare]');
    function selectKit(k){kits.forEach(function(el){var on=el===k;el.classList.toggle('is-selected',on);var r=el.querySelector('input[type=radio]');if(r)r.checked=on});
      var q=+k.dataset.qty; gifts.forEach(function(g){g.classList.toggle('is-locked',q<+g.dataset.unlock)});
      if(stickyPrice)stickyPrice.textContent=money(+k.dataset.price);
      var c=k.querySelector('.clp-kit__compare'); if(stickyCompare&&c)stickyCompare.textContent=c.textContent;}
    kits.forEach(function(k){k.addEventListener('click',function(e){if(!k.classList.contains('is-selected'))selectKit(k)})});
    if(kits[0])selectKit(kits[0]);
    root.querySelectorAll('[data-pick]').forEach(function(pk){
      var sel=pk.querySelector('select'),sw=pk.querySelector('.clp-pick__swatch');
      function upd(first){var sz=pk.querySelector('.clp-size.is-active');var v=findV(sel.value,sz?sz.dataset.size:null);if(v&&sw&&v.img)sw.src=v.img;if(v&&!first&&v.media)showMedia(v.media)}
      sel.addEventListener('change',function(){upd(false)});
      pk.querySelectorAll('.clp-size').forEach(function(b){b.addEventListener('click',function(e){e.stopPropagation();pk.querySelectorAll('.clp-size').forEach(function(x){x.classList.toggle('is-active',x===b)});upd(true)})});
      sel.addEventListener('click',function(e){e.stopPropagation()});
      upd(true);
    });
    // custom pattern swatch dropdown (drives the hidden native selects above)
    initSwatchDropdown(root);
    // add to cart
    var err=root.querySelector('[data-atc-error]');
    function add(btn){
      var k=root.querySelector('[data-kit].is-selected'); if(!k)return;
      var map={},order=[];
      k.querySelectorAll('[data-pick]').forEach(function(pk){var sz=pk.querySelector('.clp-size.is-active');var v=findV(pk.querySelector('select').value,sz?sz.dataset.size:null);if(v){if(!map[v.id]){map[v.id]=0;order.push(v.id)}map[v.id]++}});
      var kitName=k.querySelector('.clp-kit__title').textContent.trim();
      var items=order.map(function(id){return {id:id,quantity:map[id],properties:{'_bundle':kitName}}});
      if(!items.length)return;
      var giftIds=[].slice.call(root.querySelectorAll('.clp-gift[data-gift-variant]:not(.is-locked)')).map(function(g){return +g.dataset.giftVariant});
      var drawer=document.querySelector('cart-drawer');
      var addUrl=(window.routes&&routes.cart_add_url?routes.cart_add_url:'/cart/add')+'.js';
      btn.classList.add('is-loading'); if(err)err.hidden=true;
      function post(withParent,present){
        var gi=giftIds.filter(function(id){return present.indexOf(id)<0}).map(function(id){var o={id:id,quantity:1,properties:{'_gift':kitName}};if(withParent)o.parent_id=order[0];return o});
        var body={items:gi.concat(items)};
        if(drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id});body.sections_url=window.location.pathname}
        return fetch(addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json()}).then(function(res){
          if(res.status&&res.status>=400&&withParent&&gi.length)return post(false,present);
          return res;});
      }
      fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){return (c.items||[]).map(function(i){return i.variant_id})}).catch(function(){return []})
      .then(function(present){return post(true,present)})
      .then(function(res){
        btn.classList.remove('is-loading');
        if(res.status&&res.status>=400){if(err){err.textContent=res.description||res.message||'Error';err.hidden=false}return}
        if(drawer&&drawer.renderContents&&res.sections){try{res.id=items[0].id;drawer.classList.remove('is-empty');drawer.renderContents(res);return}catch(e){}}
        window.location.href=(window.routes&&routes.cart_url)||'/cart';
      }).catch(function(){btn.classList.remove('is-loading');window.location.href='/cart'});
    }
    root.querySelectorAll('[data-atc]').forEach(function(b){b.addEventListener('click',function(){add(b)})});
    // sticky
    var sticky=root.querySelector('[data-sticky]'),mainAtc=root.querySelector('.clp-info [data-atc]');
    if(sticky&&mainAtc&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){var below=e.boundingClientRect.top<0;sticky.classList.toggle('is-visible',!e.isIntersecting&&below);sticky.setAttribute('aria-hidden',!( !e.isIntersecting&&below))})}).observe(mainAtc);
    }
  }
  /* ===== Pattern swatch dropdown =====
     Custom listbox that replaces the native pattern <select> in each kit row. The select stays in the DOM
     (visually hidden) and remains the source of truth: choosing an option sets select.value and fires "change",
     so the existing swatch/gallery/add-to-cart logic keeps working. One shared list per section, portalled to
     <body> with position:fixed so it is never clipped by card overflow; only one list is open at a time. */
  var ddCloseOpen=null; // closes whichever dropdown is currently open (page-wide)
  function initSwatchDropdown(root){
    var dataEl=root.querySelector('[data-patterns]'); if(!dataEl)return;
    var pats; try{pats=JSON.parse(dataEl.textContent)}catch(e){return}
    var pickers=[].slice.call(root.querySelectorAll('[data-dd]')); if(!pats||!pats.length||!pickers.length)return;
    var newLabel=dataEl.getAttribute('data-new-label')||'NEW';
    var sid=root.getAttribute('data-section')||'x', listId='ClpDdList-'+sid;
    var old=document.getElementById(listId); if(old)old.parentNode.removeChild(old);
    var list=null,opts=[],cur=null,active=-1,raf=0,typed='',typedT=0;
    function idxOf(val){for(var i=0;i<pats.length;i++){if(pats[i].value===val)return i}return -1}
    function badge(){var b=document.createElement('span');b.className='clp-new';b.textContent=newLabel;return b}
    function build(){
      if(list)return;
      list=document.createElement('div');list.className='clp-dd__list';list.id=listId;list.setAttribute('role','listbox');list.tabIndex=-1;list.hidden=true;
      var lbl=pickers[0].querySelector('.clp-dd__btn');list.setAttribute('aria-label',(lbl&&lbl.getAttribute('aria-label'))||'Pattern');
      pats.forEach(function(p,i){
        var o=document.createElement('div');o.className='clp-dd__opt';o.id=listId+'-opt-'+i;o.setAttribute('role','option');o.setAttribute('aria-selected','false');o.dataset.i=i;
        var sw=document.createElement('span');sw.className='clp-sw';var im=document.createElement('img');im.src=p.img;im.alt='';im.width=34;im.height=34;im.decoding='async';sw.appendChild(im);
        var nm=document.createElement('span');nm.className='clp-dd__oname';nm.textContent=p.name;
        o.appendChild(sw);o.appendChild(nm);if(p.isNew)o.appendChild(badge());
        o.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();choose(i)});
        o.addEventListener('mousemove',function(){if(active!==i)setActive(i,false)});
        list.appendChild(o);opts.push(o);
      });
      list.addEventListener('mousedown',function(e){e.preventDefault()}); // keep focus on the trigger
      document.body.appendChild(list);
    }
    function btnOf(pk){return pk.querySelector('.clp-dd__btn')}
    function selOf(pk){return pk.querySelector('select')}
    function sync(pk){
      var p=pats[idxOf(selOf(pk).value)]||pats[0],b=btnOf(pk);
      var nm=b.querySelector('.clp-dd__name');if(nm)nm.textContent=p.name;
      var nb=b.querySelector('.clp-new');if(nb)nb.hidden=!p.isNew;
      var im=b.querySelector('img');if(im&&p.img&&im.getAttribute('src')!==p.img)im.src=p.img;
    }
    function setActive(i,scroll){
      active=i;opts.forEach(function(o,k){o.classList.toggle('is-active',k===i)});
      if(cur)btnOf(cur).setAttribute('aria-activedescendant',i>=0?opts[i].id:'');
      if(scroll&&i>=0){var o=opts[i];if(o.offsetTop<list.scrollTop)list.scrollTop=o.offsetTop;else if(o.offsetTop+o.offsetHeight>list.scrollTop+list.clientHeight)list.scrollTop=o.offsetTop+o.offsetHeight-list.clientHeight}
    }
    function place(){
      raf=0;if(!cur||!list)return;
      var b=btnOf(cur),r=b.getBoundingClientRect(),vw=document.documentElement.clientWidth,vh=window.innerHeight,pad=8,gap=2;
      if(r.bottom<0||r.top>vh){close(false);return} // trigger scrolled out of view
      list.style.minWidth=Math.round(r.width)+'px';list.style.maxHeight='';
      var natural=Math.min(list.scrollHeight+2,500),below=vh-r.bottom-gap-pad,above=r.top-gap-pad;
      var down=below>=Math.min(natural,280)||below>=above,room=Math.max(120,Math.min(500,down?below:above));
      list.style.maxHeight=room+'px';
      var h=Math.min(natural,room),w=list.offsetWidth;
      var left=Math.max(pad,Math.min(r.left,vw-pad-w)),top=down?r.bottom+gap:r.top-gap-h;
      list.style.left=Math.round(left)+'px';list.style.top=Math.round(top)+'px';
      list.classList.toggle('is-up',!down);
    }
    function schedule(){if(!raf)raf=requestAnimationFrame(place)}
    function open(pk){
      if(ddCloseOpen&&cur!==pk)ddCloseOpen(false);
      build();cur=pk;var b=btnOf(pk),si=idxOf(selOf(pk).value);
      opts.forEach(function(o,k){o.setAttribute('aria-selected',k===si?'true':'false')});
      list.hidden=false;b.setAttribute('aria-expanded','true');pk.classList.add('is-open');
      place();setActive(si<0?0:si,true);
      ddCloseOpen=close;
      window.addEventListener('scroll',schedule,true);window.addEventListener('resize',schedule);
    }
    function close(focus){
      if(!cur)return;var pk=cur,b=btnOf(pk);cur=null;
      if(list)list.hidden=true;b.setAttribute('aria-expanded','false');b.removeAttribute('aria-activedescendant');pk.classList.remove('is-open');
      if(ddCloseOpen===close)ddCloseOpen=null;
      window.removeEventListener('scroll',schedule,true);window.removeEventListener('resize',schedule);
      if(focus)b.focus({preventScroll:true});
    }
    function choose(i){
      var pk=cur;if(!pk||!pats[i])return;var sel=selOf(pk);
      if(sel.value!==pats[i].value){sel.value=pats[i].value;sel.dispatchEvent(new Event('change',{bubbles:true}))}
      close(true);
    }
    pickers.forEach(function(pk){
      var b=btnOf(pk),sel=selOf(pk);if(!b||!sel)return;
      sel.addEventListener('change',function(){sync(pk)});
      b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();if(cur===pk)close(false);else open(pk)});
      b.addEventListener('keydown',function(e){
        var k=e.key,n=pats.length;
        if(cur!==pk){if(k==='ArrowDown'||k==='ArrowUp'||k==='Enter'||k===' '||k==='Spacebar'){e.preventDefault();open(pk)}return}
        if(k==='Escape'){e.preventDefault();close(true)}
        else if(k==='ArrowDown'){e.preventDefault();setActive(active<n-1?active+1:0,true)}
        else if(k==='ArrowUp'){e.preventDefault();setActive(active>0?active-1:n-1,true)}
        else if(k==='Home'){e.preventDefault();setActive(0,true)}
        else if(k==='End'){e.preventDefault();setActive(n-1,true)}
        else if(k==='Enter'||k===' '||k==='Spacebar'){e.preventDefault();choose(active)}
        else if(k==='Tab'){close(false)}
        else if(k.length===1&&/\S/.test(k)){ // type-ahead
          clearTimeout(typedT);typed+=k.toLowerCase();typedT=setTimeout(function(){typed=''},600);
          for(var j=0;j<n;j++){if(pats[j].name.toLowerCase().indexOf(typed)===0){setActive(j,true);break}}
        }
      });
      sync(pk);
    });
    // tap/click outside closes; Escape closes from anywhere
    document.addEventListener('click',function(e){if(!cur)return;var t=e.target;if((list&&list.contains(t))||cur.contains(t))return;close(false)},true);
    document.addEventListener('keydown',function(e){if(cur&&e.key==='Escape')close(true)});
    // warm the swatch images once the page is idle so the first open has no pop-in
    var warm=function(){build()};('requestIdleCallback' in window)?requestIdleCallback(warm,{timeout:3000}):setTimeout(warm,1500);
  }
  function boot(){document.querySelectorAll('.clp-main').forEach(init)}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
